import React, { useRef } from 'react';
import { Card, CardContent, makeStyles, Paper, Theme, Typography } from '@material-ui/core';
import Popover from 'components/@common/Popover';
import Skeleton from 'components/@common/Skeleton';
import { isNil } from 'lodash';
import { useTranslation } from 'react-i18next';

type Props = {
  spotChecks: any;
  loading?: boolean;
};
const SpotChecksCompletedCard: React.FC<Props> = ({ loading, spotChecks }) => {
  const classes = useStyles();
  const containerRef = useRef<HTMLElement>();
  const { t } = useTranslation('Reports');
  return (
    <Paper ref={containerRef} className={classes.cardContainer}>
      <Popover description={t('spotChecksCompleted', { ns: 'ReportsHelpCards' })}>
        <Typography component="h3" variant="body2">
          {t('Spot Checks Completed')}
        </Typography>
      </Popover>
      {!loading && spotChecks ? (
        <>
          <p className={classes.primaryStatContainer}>
            <Typography variant="h1" component="span">
              {spotChecks.totalCompletedCount}
            </Typography>
            <Typography component="span" className={classes.descriptorLabel}>
              {isNil(spotChecks?.studentCompletedCount)
                ? t('completed')
                : t('completed by {{studentCompletedCount}} students', {
                    studentCompletedCount: spotChecks.studentCompletedCount
                  })}
            </Typography>
          </p>
          <Card variant="outlined" className={classes.card}>
            <CardContent className={classes.cardContent}>
              <Typography variant="body2" gutterBottom>
                {t('Average Speed')}
              </Typography>
              <Typography variant="h3" component="span">
                {spotChecks.averageWpm}
              </Typography>
              <Typography component="span" className={classes.descriptorLabel}>
                {t('words per minute')}
              </Typography>
            </CardContent>
          </Card>
          <Card variant="outlined" className={classes.card}>
            <CardContent className={classes.cardContent}>
              <Typography variant="body2" gutterBottom>
                {t('Average Accuracy')}
              </Typography>
              <Typography variant="h3" component="span">
                {spotChecks.averageAccuracy}%
              </Typography>
            </CardContent>
          </Card>
        </>
      ) : (
        <Skeleton height={containerRef.current?.clientHeight!} />
      )}
    </Paper>
  );
};
const useStyles = makeStyles((theme: Theme) => ({
  card: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1)
  },
  cardContent: {
    padding: theme.spacing(1),
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
    '&:last-child': {
      paddingBottom: theme.spacing(1)
    }
  },
  cardContainer: {
    paddingTop: theme.spacing(2),
    paddingRight: theme.spacing(4),
    paddingLeft: theme.spacing(4),
    height: '100%'
  },
  container: { marginBottom: theme.spacing(2) },
  primaryStatContainer: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(2)
  },
  descriptorLabel: {
    marginLeft: theme.spacing(0.5),
    color: theme.palette.grey[600]
  }
}));

export default SpotChecksCompletedCard;
